/**
 * This file configures the amplify library used.
 */
import { ownership } from 'src/models/ownership';
import { Config } from './config';

const commonConfig = {
  aws_project_region: Config.AwsRegion,
  aws_cognito_region: Config.AwsRegion,
  aws_user_pools_id: Config.CognitoPoolId,
  aws_user_pools_web_client_id: Config.CognitoClientId,
  federationTarget: 'COGNITO_USER_POOLS'
};

export const AmplifyConfig = {
  ...commonConfig,
  oauth: {
    scope: ['phone', 'email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
    responseType: 'code',
    domain: Config.CognitoDomain,
    ...ownership.oAuth
  }
};
